// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.5.1_webpack@5.106.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.5.1_webpack@5.106.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".expand-enter-active[data-v-7ff53f1d],.expand-leave-active[data-v-7ff53f1d]{transition:height .2s ease-in-out;overflow:hidden}.expand-enter[data-v-7ff53f1d],.expand-leave-to[data-v-7ff53f1d]{height:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
